import React from "react";
import type { ConversationDistribution } from "../../types";

interface ConversationDistributionChartProps {
  distribution: ConversationDistribution;
}

export const ConversationDistributionChart: React.FC<ConversationDistributionChartProps> = ({
  distribution,
}) => {
  const n = distribution.total;
  if (n === 0) return null;

  const buckets = [
    { key: "converted", label: "Compra", color: "#1a6e33", count: distribution.converted.count, pct: distribution.converted.pct },
    { key: "handed_off", label: "Derivada", color: "#1d5f96", count: distribution.handed_off.count, pct: distribution.handed_off.pct },
    { key: "handed_off_direct", label: "Derivación inmediata", color: "#5e3a8f", count: distribution.handed_off_direct.count, pct: distribution.handed_off_direct.pct },
    { key: "lost", label: "Abandono", color: "#a02626", count: distribution.lost.count, pct: distribution.lost.pct },
    { key: "open", label: "Abierta", color: "#a7aaad", count: distribution.open.count, pct: distribution.open.pct },
  ];

  return (
    <div
      style={{
        background: "var(--bg-surface, #111827)",
        border: "1px solid var(--border-subtle, rgba(255,255,255,0.08))",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "24px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <div>
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "var(--text-primary, #f9fafb)" }}>
            Cómo terminaron
          </h3>
          <p style={{ margin: "4px 0 0", fontSize: "12px", color: "var(--text-muted, #9ca3af)" }}>
            Distribución exclusiva de resolución efectiva sobre {n.toLocaleString("es-CL")} conversaciones iniciadas (100%)
          </p>
        </div>
      </div>

      {/* Barra Horizontal Apilada al 100% */}
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "36px",
          borderRadius: "6px",
          overflow: "hidden",
          background: "rgba(255,255,255,0.05)",
          marginBottom: "16px",
        }}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={100}
      >
        {buckets.map((b) => {
          if (b.count === 0) return null;
          const widthPct = (b.count / n) * 100;
          return (
            <div
              key={b.key}
              title={`${b.label}: ${b.count} (${widthPct.toFixed(1)}%)`}
              style={{
                width: `${widthPct}%`,
                background: b.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "12px",
                fontWeight: 600,
                transition: "width 0.3s ease",
                minWidth: widthPct > 4 ? "auto" : "0px",
              }}
            >
              {widthPct >= 8 ? `${widthPct.toFixed(0)}%` : ""}
            </div>
          );
        })}
      </div>

      {/* Leyenda Didáctica con los 5 baldes */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }}>
        {buckets.map((b) => (
          <div key={b.key} style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px" }}>
            <span
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "3px",
                background: b.color,
                display: "inline-block",
              }}
            />
            <span style={{ color: "var(--text-muted, #9ca3af)" }}>{b.label}:</span>
            <strong style={{ color: "var(--text-primary, #f9fafb)" }}>{b.count}</strong>
            <span style={{ color: "var(--text-muted, #9ca3af)", fontSize: "12px" }}>
              ({b.pct}%)
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
